/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Promotion_Sign_In_DescriptionInputs */

const en_directory_promotion_sign_in_description = /** @type {(inputs: Directory_Promotion_Sign_In_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sign in to check your Sponsor plan and continue.`)
};

const zh_directory_promotion_sign_in_description = /** @type {(inputs: Directory_Promotion_Sign_In_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`登录后即可检查 Sponsor 套餐状态并继续。`)
};

/**
* | output |
* | --- |
* | "Sign in to check your Sponsor plan and continue." |
*
* @param {Directory_Promotion_Sign_In_DescriptionInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_promotion_sign_in_description = /** @type {((inputs?: Directory_Promotion_Sign_In_DescriptionInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Promotion_Sign_In_DescriptionInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_promotion_sign_in_description(inputs)
	return zh_directory_promotion_sign_in_description(inputs)
});
export { directory_promotion_sign_in_description as "directory.promotion.sign_in_description" }